/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { apiHotelManageEditGroupBreakfastPost } from '../fn/edit-hotel-room-rack-info-endpoint/api-hotel-manage-edit-group-breakfast-post';
import { ApiHotelManageEditGroupBreakfastPost$Params } from '../fn/edit-hotel-room-rack-info-endpoint/api-hotel-manage-edit-group-breakfast-post';
import { apiHotelManageEditGroupCheckinLimitPost } from '../fn/edit-hotel-room-rack-info-endpoint/api-hotel-manage-edit-group-checkin-limit-post';
import { ApiHotelManageEditGroupCheckinLimitPost$Params } from '../fn/edit-hotel-room-rack-info-endpoint/api-hotel-manage-edit-group-checkin-limit-post';
import { apiHotelManageEditGroupCheckoutLimitPost } from '../fn/edit-hotel-room-rack-info-endpoint/api-hotel-manage-edit-group-checkout-limit-post';
import { ApiHotelManageEditGroupCheckoutLimitPost$Params } from '../fn/edit-hotel-room-rack-info-endpoint/api-hotel-manage-edit-group-checkout-limit-post';
import { apiHotelManageEditGroupCommissionPercentPost } from '../fn/edit-hotel-room-rack-info-endpoint/api-hotel-manage-edit-group-commission-percent-post';
import { ApiHotelManageEditGroupCommissionPercentPost$Params } from '../fn/edit-hotel-room-rack-info-endpoint/api-hotel-manage-edit-group-commission-percent-post';
import { apiHotelManageEditGroupDinnerPost } from '../fn/edit-hotel-room-rack-info-endpoint/api-hotel-manage-edit-group-dinner-post';
import { ApiHotelManageEditGroupDinnerPost$Params } from '../fn/edit-hotel-room-rack-info-endpoint/api-hotel-manage-edit-group-dinner-post';
import { apiHotelManageEditGroupGlancePost } from '../fn/edit-hotel-room-rack-info-endpoint/api-hotel-manage-edit-group-glance-post';
import { ApiHotelManageEditGroupGlancePost$Params } from '../fn/edit-hotel-room-rack-info-endpoint/api-hotel-manage-edit-group-glance-post';
import { apiHotelManageEditGroupLunchPost } from '../fn/edit-hotel-room-rack-info-endpoint/api-hotel-manage-edit-group-lunch-post';
import { ApiHotelManageEditGroupLunchPost$Params } from '../fn/edit-hotel-room-rack-info-endpoint/api-hotel-manage-edit-group-lunch-post';
import { apiHotelManageEditGroupMaxdaysRestrictionPost } from '../fn/edit-hotel-room-rack-info-endpoint/api-hotel-manage-edit-group-maxdays-restriction-post';
import { ApiHotelManageEditGroupMaxdaysRestrictionPost$Params } from '../fn/edit-hotel-room-rack-info-endpoint/api-hotel-manage-edit-group-maxdays-restriction-post';
import { apiHotelManageEditGroupMindaysRestrictionPost } from '../fn/edit-hotel-room-rack-info-endpoint/api-hotel-manage-edit-group-mindays-restriction-post';
import { ApiHotelManageEditGroupMindaysRestrictionPost$Params } from '../fn/edit-hotel-room-rack-info-endpoint/api-hotel-manage-edit-group-mindays-restriction-post';
import { apiHotelManageEditGroupNetActivePost } from '../fn/edit-hotel-room-rack-info-endpoint/api-hotel-manage-edit-group-net-active-post';
import { ApiHotelManageEditGroupNetActivePost$Params } from '../fn/edit-hotel-room-rack-info-endpoint/api-hotel-manage-edit-group-net-active-post';
import { apiHotelManageEditGroupOtherServicesPost } from '../fn/edit-hotel-room-rack-info-endpoint/api-hotel-manage-edit-group-other-services-post';
import { ApiHotelManageEditGroupOtherServicesPost$Params } from '../fn/edit-hotel-room-rack-info-endpoint/api-hotel-manage-edit-group-other-services-post';
import { apiHotelManageEditGroupPricePost } from '../fn/edit-hotel-room-rack-info-endpoint/api-hotel-manage-edit-group-price-post';
import { ApiHotelManageEditGroupPricePost$Params } from '../fn/edit-hotel-room-rack-info-endpoint/api-hotel-manage-edit-group-price-post';
import { apiHotelManageEditGroupServiceCommissionPercentPost } from '../fn/edit-hotel-room-rack-info-endpoint/api-hotel-manage-edit-group-service-commission-percent-post';
import { ApiHotelManageEditGroupServiceCommissionPercentPost$Params } from '../fn/edit-hotel-room-rack-info-endpoint/api-hotel-manage-edit-group-service-commission-percent-post';
import { apiHotelManageEditGroupServicePricePost } from '../fn/edit-hotel-room-rack-info-endpoint/api-hotel-manage-edit-group-service-price-post';
import { ApiHotelManageEditGroupServicePricePost$Params } from '../fn/edit-hotel-room-rack-info-endpoint/api-hotel-manage-edit-group-service-price-post';
import { apiHotelManageEditGroupTransferPost } from '../fn/edit-hotel-room-rack-info-endpoint/api-hotel-manage-edit-group-transfer-post';
import { ApiHotelManageEditGroupTransferPost$Params } from '../fn/edit-hotel-room-rack-info-endpoint/api-hotel-manage-edit-group-transfer-post';
import { apiHotelManageEditSingleBreakfastPost } from '../fn/edit-hotel-room-rack-info-endpoint/api-hotel-manage-edit-single-breakfast-post';
import { ApiHotelManageEditSingleBreakfastPost$Params } from '../fn/edit-hotel-room-rack-info-endpoint/api-hotel-manage-edit-single-breakfast-post';
import { apiHotelManageEditSingleCheckinLimitPost } from '../fn/edit-hotel-room-rack-info-endpoint/api-hotel-manage-edit-single-checkin-limit-post';
import { ApiHotelManageEditSingleCheckinLimitPost$Params } from '../fn/edit-hotel-room-rack-info-endpoint/api-hotel-manage-edit-single-checkin-limit-post';
import { apiHotelManageEditSingleCheckoutLimitPost } from '../fn/edit-hotel-room-rack-info-endpoint/api-hotel-manage-edit-single-checkout-limit-post';
import { ApiHotelManageEditSingleCheckoutLimitPost$Params } from '../fn/edit-hotel-room-rack-info-endpoint/api-hotel-manage-edit-single-checkout-limit-post';
import { apiHotelManageEditSingleCommissionPercentPost } from '../fn/edit-hotel-room-rack-info-endpoint/api-hotel-manage-edit-single-commission-percent-post';
import { ApiHotelManageEditSingleCommissionPercentPost$Params } from '../fn/edit-hotel-room-rack-info-endpoint/api-hotel-manage-edit-single-commission-percent-post';
import { apiHotelManageEditSingleDinnerPost } from '../fn/edit-hotel-room-rack-info-endpoint/api-hotel-manage-edit-single-dinner-post';
import { ApiHotelManageEditSingleDinnerPost$Params } from '../fn/edit-hotel-room-rack-info-endpoint/api-hotel-manage-edit-single-dinner-post';
import { apiHotelManageEditSingleGlancePost } from '../fn/edit-hotel-room-rack-info-endpoint/api-hotel-manage-edit-single-glance-post';
import { ApiHotelManageEditSingleGlancePost$Params } from '../fn/edit-hotel-room-rack-info-endpoint/api-hotel-manage-edit-single-glance-post';
import { apiHotelManageEditSingleLunchPost } from '../fn/edit-hotel-room-rack-info-endpoint/api-hotel-manage-edit-single-lunch-post';
import { ApiHotelManageEditSingleLunchPost$Params } from '../fn/edit-hotel-room-rack-info-endpoint/api-hotel-manage-edit-single-lunch-post';
import { apiHotelManageEditSingleMaxdaysRestrictionPost } from '../fn/edit-hotel-room-rack-info-endpoint/api-hotel-manage-edit-single-maxdays-restriction-post';
import { ApiHotelManageEditSingleMaxdaysRestrictionPost$Params } from '../fn/edit-hotel-room-rack-info-endpoint/api-hotel-manage-edit-single-maxdays-restriction-post';
import { apiHotelManageEditSingleMindaysRestrictionPost } from '../fn/edit-hotel-room-rack-info-endpoint/api-hotel-manage-edit-single-mindays-restriction-post';
import { ApiHotelManageEditSingleMindaysRestrictionPost$Params } from '../fn/edit-hotel-room-rack-info-endpoint/api-hotel-manage-edit-single-mindays-restriction-post';
import { apiHotelManageEditSingleNetActivePost } from '../fn/edit-hotel-room-rack-info-endpoint/api-hotel-manage-edit-single-net-active-post';
import { ApiHotelManageEditSingleNetActivePost$Params } from '../fn/edit-hotel-room-rack-info-endpoint/api-hotel-manage-edit-single-net-active-post';
import { apiHotelManageEditSingleOtherServicesPost } from '../fn/edit-hotel-room-rack-info-endpoint/api-hotel-manage-edit-single-other-services-post';
import { ApiHotelManageEditSingleOtherServicesPost$Params } from '../fn/edit-hotel-room-rack-info-endpoint/api-hotel-manage-edit-single-other-services-post';
import { apiHotelManageEditSinglePricePost } from '../fn/edit-hotel-room-rack-info-endpoint/api-hotel-manage-edit-single-price-post';
import { ApiHotelManageEditSinglePricePost$Params } from '../fn/edit-hotel-room-rack-info-endpoint/api-hotel-manage-edit-single-price-post';
import { apiHotelManageEditSingleRemainedQuotaPost } from '../fn/edit-hotel-room-rack-info-endpoint/api-hotel-manage-edit-single-remained-quota-post';
import { ApiHotelManageEditSingleRemainedQuotaPost$Params } from '../fn/edit-hotel-room-rack-info-endpoint/api-hotel-manage-edit-single-remained-quota-post';
import { apiHotelManageEditSingleServiceCommissionPercentPost } from '../fn/edit-hotel-room-rack-info-endpoint/api-hotel-manage-edit-single-service-commission-percent-post';
import { ApiHotelManageEditSingleServiceCommissionPercentPost$Params } from '../fn/edit-hotel-room-rack-info-endpoint/api-hotel-manage-edit-single-service-commission-percent-post';
import { apiHotelManageEditSingleServicePricePost } from '../fn/edit-hotel-room-rack-info-endpoint/api-hotel-manage-edit-single-service-price-post';
import { ApiHotelManageEditSingleServicePricePost$Params } from '../fn/edit-hotel-room-rack-info-endpoint/api-hotel-manage-edit-single-service-price-post';
import { apiHotelManageEditSingleTransferPost } from '../fn/edit-hotel-room-rack-info-endpoint/api-hotel-manage-edit-single-transfer-post';
import { ApiHotelManageEditSingleTransferPost$Params } from '../fn/edit-hotel-room-rack-info-endpoint/api-hotel-manage-edit-single-transfer-post';

@Injectable({ providedIn: 'root' })
export class EditHotelRoomRackInfoEndpointService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `apiHotelManageEditSinglePricePost()` */
  static readonly ApiHotelManageEditSinglePricePostPath = '/api/hotel/manage/edit/single/price';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiHotelManageEditSinglePricePost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiHotelManageEditSinglePricePost$Response(params: ApiHotelManageEditSinglePricePost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return apiHotelManageEditSinglePricePost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiHotelManageEditSinglePricePost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiHotelManageEditSinglePricePost(params: ApiHotelManageEditSinglePricePost$Params, context?: HttpContext): Observable<void> {
    return this.apiHotelManageEditSinglePricePost$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiHotelManageEditSingleCommissionPercentPost()` */
  static readonly ApiHotelManageEditSingleCommissionPercentPostPath = '/api/hotel/manage/edit/single/commission-percent';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiHotelManageEditSingleCommissionPercentPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiHotelManageEditSingleCommissionPercentPost$Response(params: ApiHotelManageEditSingleCommissionPercentPost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return apiHotelManageEditSingleCommissionPercentPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiHotelManageEditSingleCommissionPercentPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiHotelManageEditSingleCommissionPercentPost(params: ApiHotelManageEditSingleCommissionPercentPost$Params, context?: HttpContext): Observable<void> {
    return this.apiHotelManageEditSingleCommissionPercentPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiHotelManageEditSingleRemainedQuotaPost()` */
  static readonly ApiHotelManageEditSingleRemainedQuotaPostPath = '/api/hotel/manage/edit/single/remained-quota';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiHotelManageEditSingleRemainedQuotaPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiHotelManageEditSingleRemainedQuotaPost$Response(params: ApiHotelManageEditSingleRemainedQuotaPost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return apiHotelManageEditSingleRemainedQuotaPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiHotelManageEditSingleRemainedQuotaPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiHotelManageEditSingleRemainedQuotaPost(params: ApiHotelManageEditSingleRemainedQuotaPost$Params, context?: HttpContext): Observable<void> {
    return this.apiHotelManageEditSingleRemainedQuotaPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiHotelManageEditSingleBreakfastPost()` */
  static readonly ApiHotelManageEditSingleBreakfastPostPath = '/api/hotel/manage/edit/single/breakfast';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiHotelManageEditSingleBreakfastPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiHotelManageEditSingleBreakfastPost$Response(params: ApiHotelManageEditSingleBreakfastPost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return apiHotelManageEditSingleBreakfastPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiHotelManageEditSingleBreakfastPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiHotelManageEditSingleBreakfastPost(params: ApiHotelManageEditSingleBreakfastPost$Params, context?: HttpContext): Observable<void> {
    return this.apiHotelManageEditSingleBreakfastPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiHotelManageEditSingleLunchPost()` */
  static readonly ApiHotelManageEditSingleLunchPostPath = '/api/hotel/manage/edit/single/lunch';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiHotelManageEditSingleLunchPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiHotelManageEditSingleLunchPost$Response(params: ApiHotelManageEditSingleLunchPost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return apiHotelManageEditSingleLunchPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiHotelManageEditSingleLunchPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiHotelManageEditSingleLunchPost(params: ApiHotelManageEditSingleLunchPost$Params, context?: HttpContext): Observable<void> {
    return this.apiHotelManageEditSingleLunchPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiHotelManageEditSingleDinnerPost()` */
  static readonly ApiHotelManageEditSingleDinnerPostPath = '/api/hotel/manage/edit/single/dinner';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiHotelManageEditSingleDinnerPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiHotelManageEditSingleDinnerPost$Response(params: ApiHotelManageEditSingleDinnerPost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return apiHotelManageEditSingleDinnerPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiHotelManageEditSingleDinnerPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiHotelManageEditSingleDinnerPost(params: ApiHotelManageEditSingleDinnerPost$Params, context?: HttpContext): Observable<void> {
    return this.apiHotelManageEditSingleDinnerPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiHotelManageEditSingleTransferPost()` */
  static readonly ApiHotelManageEditSingleTransferPostPath = '/api/hotel/manage/edit/single/transfer';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiHotelManageEditSingleTransferPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiHotelManageEditSingleTransferPost$Response(params: ApiHotelManageEditSingleTransferPost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return apiHotelManageEditSingleTransferPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiHotelManageEditSingleTransferPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiHotelManageEditSingleTransferPost(params: ApiHotelManageEditSingleTransferPost$Params, context?: HttpContext): Observable<void> {
    return this.apiHotelManageEditSingleTransferPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiHotelManageEditSingleGlancePost()` */
  static readonly ApiHotelManageEditSingleGlancePostPath = '/api/hotel/manage/edit/single/glance';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiHotelManageEditSingleGlancePost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiHotelManageEditSingleGlancePost$Response(params: ApiHotelManageEditSingleGlancePost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return apiHotelManageEditSingleGlancePost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiHotelManageEditSingleGlancePost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiHotelManageEditSingleGlancePost(params: ApiHotelManageEditSingleGlancePost$Params, context?: HttpContext): Observable<void> {
    return this.apiHotelManageEditSingleGlancePost$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiHotelManageEditSingleCheckinLimitPost()` */
  static readonly ApiHotelManageEditSingleCheckinLimitPostPath = '/api/hotel/manage/edit/single/checkin-limit';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiHotelManageEditSingleCheckinLimitPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiHotelManageEditSingleCheckinLimitPost$Response(params: ApiHotelManageEditSingleCheckinLimitPost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return apiHotelManageEditSingleCheckinLimitPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiHotelManageEditSingleCheckinLimitPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiHotelManageEditSingleCheckinLimitPost(params: ApiHotelManageEditSingleCheckinLimitPost$Params, context?: HttpContext): Observable<void> {
    return this.apiHotelManageEditSingleCheckinLimitPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiHotelManageEditSingleCheckoutLimitPost()` */
  static readonly ApiHotelManageEditSingleCheckoutLimitPostPath = '/api/hotel/manage/edit/single/checkout-limit';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiHotelManageEditSingleCheckoutLimitPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiHotelManageEditSingleCheckoutLimitPost$Response(params: ApiHotelManageEditSingleCheckoutLimitPost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return apiHotelManageEditSingleCheckoutLimitPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiHotelManageEditSingleCheckoutLimitPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiHotelManageEditSingleCheckoutLimitPost(params: ApiHotelManageEditSingleCheckoutLimitPost$Params, context?: HttpContext): Observable<void> {
    return this.apiHotelManageEditSingleCheckoutLimitPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiHotelManageEditSingleMindaysRestrictionPost()` */
  static readonly ApiHotelManageEditSingleMindaysRestrictionPostPath = '/api/hotel/manage/edit/single/mindays-restriction';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiHotelManageEditSingleMindaysRestrictionPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiHotelManageEditSingleMindaysRestrictionPost$Response(params: ApiHotelManageEditSingleMindaysRestrictionPost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return apiHotelManageEditSingleMindaysRestrictionPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiHotelManageEditSingleMindaysRestrictionPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiHotelManageEditSingleMindaysRestrictionPost(params: ApiHotelManageEditSingleMindaysRestrictionPost$Params, context?: HttpContext): Observable<void> {
    return this.apiHotelManageEditSingleMindaysRestrictionPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiHotelManageEditSingleMaxdaysRestrictionPost()` */
  static readonly ApiHotelManageEditSingleMaxdaysRestrictionPostPath = '/api/hotel/manage/edit/single/maxdays-restriction';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiHotelManageEditSingleMaxdaysRestrictionPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiHotelManageEditSingleMaxdaysRestrictionPost$Response(params: ApiHotelManageEditSingleMaxdaysRestrictionPost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return apiHotelManageEditSingleMaxdaysRestrictionPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiHotelManageEditSingleMaxdaysRestrictionPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiHotelManageEditSingleMaxdaysRestrictionPost(params: ApiHotelManageEditSingleMaxdaysRestrictionPost$Params, context?: HttpContext): Observable<void> {
    return this.apiHotelManageEditSingleMaxdaysRestrictionPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiHotelManageEditSingleOtherServicesPost()` */
  static readonly ApiHotelManageEditSingleOtherServicesPostPath = '/api/hotel/manage/edit/single/other-services';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiHotelManageEditSingleOtherServicesPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiHotelManageEditSingleOtherServicesPost$Response(params: ApiHotelManageEditSingleOtherServicesPost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return apiHotelManageEditSingleOtherServicesPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiHotelManageEditSingleOtherServicesPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiHotelManageEditSingleOtherServicesPost(params: ApiHotelManageEditSingleOtherServicesPost$Params, context?: HttpContext): Observable<void> {
    return this.apiHotelManageEditSingleOtherServicesPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiHotelManageEditSingleServicePricePost()` */
  static readonly ApiHotelManageEditSingleServicePricePostPath = '/api/hotel/manage/edit/single/service-price';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiHotelManageEditSingleServicePricePost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiHotelManageEditSingleServicePricePost$Response(params: ApiHotelManageEditSingleServicePricePost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return apiHotelManageEditSingleServicePricePost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiHotelManageEditSingleServicePricePost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiHotelManageEditSingleServicePricePost(params: ApiHotelManageEditSingleServicePricePost$Params, context?: HttpContext): Observable<void> {
    return this.apiHotelManageEditSingleServicePricePost$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiHotelManageEditSingleServiceCommissionPercentPost()` */
  static readonly ApiHotelManageEditSingleServiceCommissionPercentPostPath = '/api/hotel/manage/edit/single/service-commission-percent';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiHotelManageEditSingleServiceCommissionPercentPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiHotelManageEditSingleServiceCommissionPercentPost$Response(params: ApiHotelManageEditSingleServiceCommissionPercentPost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return apiHotelManageEditSingleServiceCommissionPercentPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiHotelManageEditSingleServiceCommissionPercentPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiHotelManageEditSingleServiceCommissionPercentPost(params: ApiHotelManageEditSingleServiceCommissionPercentPost$Params, context?: HttpContext): Observable<void> {
    return this.apiHotelManageEditSingleServiceCommissionPercentPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiHotelManageEditSingleNetActivePost()` */
  static readonly ApiHotelManageEditSingleNetActivePostPath = '/api/hotel/manage/edit/single/net-active';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiHotelManageEditSingleNetActivePost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiHotelManageEditSingleNetActivePost$Response(params: ApiHotelManageEditSingleNetActivePost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return apiHotelManageEditSingleNetActivePost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiHotelManageEditSingleNetActivePost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiHotelManageEditSingleNetActivePost(params: ApiHotelManageEditSingleNetActivePost$Params, context?: HttpContext): Observable<void> {
    return this.apiHotelManageEditSingleNetActivePost$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiHotelManageEditGroupPricePost()` */
  static readonly ApiHotelManageEditGroupPricePostPath = '/api/hotel/manage/edit/group/price';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiHotelManageEditGroupPricePost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiHotelManageEditGroupPricePost$Response(params: ApiHotelManageEditGroupPricePost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return apiHotelManageEditGroupPricePost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiHotelManageEditGroupPricePost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiHotelManageEditGroupPricePost(params: ApiHotelManageEditGroupPricePost$Params, context?: HttpContext): Observable<void> {
    return this.apiHotelManageEditGroupPricePost$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiHotelManageEditGroupCommissionPercentPost()` */
  static readonly ApiHotelManageEditGroupCommissionPercentPostPath = '/api/hotel/manage/edit/group/commission-percent';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiHotelManageEditGroupCommissionPercentPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiHotelManageEditGroupCommissionPercentPost$Response(params: ApiHotelManageEditGroupCommissionPercentPost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return apiHotelManageEditGroupCommissionPercentPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiHotelManageEditGroupCommissionPercentPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiHotelManageEditGroupCommissionPercentPost(params: ApiHotelManageEditGroupCommissionPercentPost$Params, context?: HttpContext): Observable<void> {
    return this.apiHotelManageEditGroupCommissionPercentPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiHotelManageEditGroupBreakfastPost()` */
  static readonly ApiHotelManageEditGroupBreakfastPostPath = '/api/hotel/manage/edit/group/breakfast';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiHotelManageEditGroupBreakfastPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiHotelManageEditGroupBreakfastPost$Response(params: ApiHotelManageEditGroupBreakfastPost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return apiHotelManageEditGroupBreakfastPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiHotelManageEditGroupBreakfastPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiHotelManageEditGroupBreakfastPost(params: ApiHotelManageEditGroupBreakfastPost$Params, context?: HttpContext): Observable<void> {
    return this.apiHotelManageEditGroupBreakfastPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiHotelManageEditGroupLunchPost()` */
  static readonly ApiHotelManageEditGroupLunchPostPath = '/api/hotel/manage/edit/group/lunch';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiHotelManageEditGroupLunchPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiHotelManageEditGroupLunchPost$Response(params: ApiHotelManageEditGroupLunchPost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return apiHotelManageEditGroupLunchPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiHotelManageEditGroupLunchPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiHotelManageEditGroupLunchPost(params: ApiHotelManageEditGroupLunchPost$Params, context?: HttpContext): Observable<void> {
    return this.apiHotelManageEditGroupLunchPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiHotelManageEditGroupDinnerPost()` */
  static readonly ApiHotelManageEditGroupDinnerPostPath = '/api/hotel/manage/edit/group/dinner';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiHotelManageEditGroupDinnerPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiHotelManageEditGroupDinnerPost$Response(params: ApiHotelManageEditGroupDinnerPost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return apiHotelManageEditGroupDinnerPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiHotelManageEditGroupDinnerPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiHotelManageEditGroupDinnerPost(params: ApiHotelManageEditGroupDinnerPost$Params, context?: HttpContext): Observable<void> {
    return this.apiHotelManageEditGroupDinnerPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiHotelManageEditGroupTransferPost()` */
  static readonly ApiHotelManageEditGroupTransferPostPath = '/api/hotel/manage/edit/group/transfer';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiHotelManageEditGroupTransferPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiHotelManageEditGroupTransferPost$Response(params: ApiHotelManageEditGroupTransferPost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return apiHotelManageEditGroupTransferPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiHotelManageEditGroupTransferPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiHotelManageEditGroupTransferPost(params: ApiHotelManageEditGroupTransferPost$Params, context?: HttpContext): Observable<void> {
    return this.apiHotelManageEditGroupTransferPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiHotelManageEditGroupGlancePost()` */
  static readonly ApiHotelManageEditGroupGlancePostPath = '/api/hotel/manage/edit/group/glance';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiHotelManageEditGroupGlancePost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiHotelManageEditGroupGlancePost$Response(params: ApiHotelManageEditGroupGlancePost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return apiHotelManageEditGroupGlancePost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiHotelManageEditGroupGlancePost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiHotelManageEditGroupGlancePost(params: ApiHotelManageEditGroupGlancePost$Params, context?: HttpContext): Observable<void> {
    return this.apiHotelManageEditGroupGlancePost$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiHotelManageEditGroupCheckinLimitPost()` */
  static readonly ApiHotelManageEditGroupCheckinLimitPostPath = '/api/hotel/manage/edit/group/checkin-limit';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiHotelManageEditGroupCheckinLimitPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiHotelManageEditGroupCheckinLimitPost$Response(params: ApiHotelManageEditGroupCheckinLimitPost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return apiHotelManageEditGroupCheckinLimitPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiHotelManageEditGroupCheckinLimitPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiHotelManageEditGroupCheckinLimitPost(params: ApiHotelManageEditGroupCheckinLimitPost$Params, context?: HttpContext): Observable<void> {
    return this.apiHotelManageEditGroupCheckinLimitPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiHotelManageEditGroupCheckoutLimitPost()` */
  static readonly ApiHotelManageEditGroupCheckoutLimitPostPath = '/api/hotel/manage/edit/group/checkout-limit';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiHotelManageEditGroupCheckoutLimitPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiHotelManageEditGroupCheckoutLimitPost$Response(params: ApiHotelManageEditGroupCheckoutLimitPost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return apiHotelManageEditGroupCheckoutLimitPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiHotelManageEditGroupCheckoutLimitPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiHotelManageEditGroupCheckoutLimitPost(params: ApiHotelManageEditGroupCheckoutLimitPost$Params, context?: HttpContext): Observable<void> {
    return this.apiHotelManageEditGroupCheckoutLimitPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiHotelManageEditGroupMindaysRestrictionPost()` */
  static readonly ApiHotelManageEditGroupMindaysRestrictionPostPath = '/api/hotel/manage/edit/group/mindays-restriction';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiHotelManageEditGroupMindaysRestrictionPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiHotelManageEditGroupMindaysRestrictionPost$Response(params: ApiHotelManageEditGroupMindaysRestrictionPost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return apiHotelManageEditGroupMindaysRestrictionPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiHotelManageEditGroupMindaysRestrictionPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiHotelManageEditGroupMindaysRestrictionPost(params: ApiHotelManageEditGroupMindaysRestrictionPost$Params, context?: HttpContext): Observable<void> {
    return this.apiHotelManageEditGroupMindaysRestrictionPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiHotelManageEditGroupMaxdaysRestrictionPost()` */
  static readonly ApiHotelManageEditGroupMaxdaysRestrictionPostPath = '/api/hotel/manage/edit/group/maxdays-restriction';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiHotelManageEditGroupMaxdaysRestrictionPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiHotelManageEditGroupMaxdaysRestrictionPost$Response(params: ApiHotelManageEditGroupMaxdaysRestrictionPost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return apiHotelManageEditGroupMaxdaysRestrictionPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiHotelManageEditGroupMaxdaysRestrictionPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiHotelManageEditGroupMaxdaysRestrictionPost(params: ApiHotelManageEditGroupMaxdaysRestrictionPost$Params, context?: HttpContext): Observable<void> {
    return this.apiHotelManageEditGroupMaxdaysRestrictionPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiHotelManageEditGroupOtherServicesPost()` */
  static readonly ApiHotelManageEditGroupOtherServicesPostPath = '/api/hotel/manage/edit/group/other-services';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiHotelManageEditGroupOtherServicesPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiHotelManageEditGroupOtherServicesPost$Response(params: ApiHotelManageEditGroupOtherServicesPost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return apiHotelManageEditGroupOtherServicesPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiHotelManageEditGroupOtherServicesPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiHotelManageEditGroupOtherServicesPost(params: ApiHotelManageEditGroupOtherServicesPost$Params, context?: HttpContext): Observable<void> {
    return this.apiHotelManageEditGroupOtherServicesPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiHotelManageEditGroupServicePricePost()` */
  static readonly ApiHotelManageEditGroupServicePricePostPath = '/api/hotel/manage/edit/group/service-price';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiHotelManageEditGroupServicePricePost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiHotelManageEditGroupServicePricePost$Response(params: ApiHotelManageEditGroupServicePricePost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return apiHotelManageEditGroupServicePricePost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiHotelManageEditGroupServicePricePost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiHotelManageEditGroupServicePricePost(params: ApiHotelManageEditGroupServicePricePost$Params, context?: HttpContext): Observable<void> {
    return this.apiHotelManageEditGroupServicePricePost$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiHotelManageEditGroupServiceCommissionPercentPost()` */
  static readonly ApiHotelManageEditGroupServiceCommissionPercentPostPath = '/api/hotel/manage/edit/group/service-commission-percent';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiHotelManageEditGroupServiceCommissionPercentPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiHotelManageEditGroupServiceCommissionPercentPost$Response(params: ApiHotelManageEditGroupServiceCommissionPercentPost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return apiHotelManageEditGroupServiceCommissionPercentPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiHotelManageEditGroupServiceCommissionPercentPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiHotelManageEditGroupServiceCommissionPercentPost(params: ApiHotelManageEditGroupServiceCommissionPercentPost$Params, context?: HttpContext): Observable<void> {
    return this.apiHotelManageEditGroupServiceCommissionPercentPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiHotelManageEditGroupNetActivePost()` */
  static readonly ApiHotelManageEditGroupNetActivePostPath = '/api/hotel/manage/edit/group/net-active';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiHotelManageEditGroupNetActivePost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiHotelManageEditGroupNetActivePost$Response(params: ApiHotelManageEditGroupNetActivePost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return apiHotelManageEditGroupNetActivePost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiHotelManageEditGroupNetActivePost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiHotelManageEditGroupNetActivePost(params: ApiHotelManageEditGroupNetActivePost$Params, context?: HttpContext): Observable<void> {
    return this.apiHotelManageEditGroupNetActivePost$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
